import { APP_NAME } from './constants'

interface SetCookieProps {
	key: string
	value: string
	path?: string
	daysToExpire?: number
	expiresIn?: number
}

export default class CookieStorage {
	public appName = APP_NAME

	private getKey(key: string) {
		return `${this.appName}/${key}`
	}

	public get(key: string): string | null {
		const name = `${this.getKey(key)}=`
		const cookies = document.cookie.split('; ')

		const cookie = cookies.find((savedCookie) => savedCookie.startsWith(name))

		return cookie ? decodeURIComponent(cookie.substring(name.length)) : null
	}

	public set({
		key,
		value,
		daysToExpire,
		expiresIn,
		path = '/',
	}: SetCookieProps) {
		const parts = [
			`${this.getKey(key)}=${encodeURIComponent(value)}`,
			`path=${path}`,
		]

		if (daysToExpire || expiresIn) {
			const expires = new Date()
			const expiresDate = daysToExpire
				? daysToExpire * 24 * 60 * 60 * 1000
				: expiresIn ?? 0

			expires.setTime(expires.getTime() + expiresDate)
			parts.push(`expires=${expires.toUTCString()}`)
		}

		document.cookie = parts.join('; ')
	}

	public remove(key: string, path?: '/') {
		const pastDate = new Date(0).toUTCString()

		document.cookie = `${this.getKey(key)}=; expires=${pastDate}; path=${path};`
	}

	public removeSessionCookies() {
		const cookies = document.cookie.split('; ')
		const appPrefix = `${this.appName}/`

		cookies.forEach((cookie) => {
			const [name] = cookie.split('=')

			if (name.startsWith(appPrefix)) {
				const hasExpires = cookie.includes('expires=')

				if (!hasExpires) {
					this.remove(name.substring(appPrefix.length))
				}
			}
		})
	}
}
